import React, { useEffect, useRef } from "react";
import ReactDatePicker, { ReactDatePickerProps } from "react-datepicker";
import { Input, Box } from "@chakra-ui/react";
import "react-datepicker/dist/react-datepicker";
import moment from "moment";
import { RefCallBack } from "react-hook-form";

interface DatePickerProps {
  name: string;
  selected: Date | undefined;
  onChange: (date: Date) => void;
  inputRef: RefCallBack;
  pickerProps?: Partial<ReactDatePickerProps<unknown>>;
  initialFormat?: string;
}

const DatePicker: React.FC<DatePickerProps> = ({
  name,
  selected,
  onChange,
  inputRef,
  initialFormat = "MM/DD/YYYY",
  pickerProps = {},
}: DatePickerProps) => {
  // This is here to set the initial value of the custom Input, otherwise it
  // gets set to the ISO string stored in the form state before ReactDatePicker
  // takes it over.
  const customInputRef = useRef<any>(null);
  useEffect(() => {
    if (customInputRef.current.input && inputRef) {
      inputRef(customInputRef.current.input);
      customInputRef.current.input.value =
        moment(selected).format(initialFormat);
    }
  }, []);

  return (
    <Box
      sx={{
        ".react-datepicker-wrapper": { width: "100%" },
      }}
    >
      <ReactDatePicker
        ref={(e: any) => (customInputRef.current = e)}
        name={name}
        selected={selected}
        onChange={onChange}
        showPopperArrow={false}
        autoComplete="off"
        popperPlacement="top-start"
        customInput={<Input w="100%" />}
        {...pickerProps}
      />
    </Box>
  );
};

export default DatePicker;
